
/*
  FRADIME SHARED SIZE ENGINE V1

  One calculation engine for the Size Guide page and
  product-page calculator.

  Inputs are in inches.
  No automatic size-up.
  No body-to-garment fit assumptions.
*/

(function () {
  "use strict";

  var PAIRS = {
    "t-shirt": ["A", "B"],
    "450-gsm-hoodie": ["A", "B"],
    "400-gsm-hoodie": ["A", "B"],
    "polo-shirt": ["A", "B"],
    "cuban-collar-shirt": ["A", "B"],
    "cargos": ["A", "D"],
    "zip-up-shorts": ["A", "D"],
    "swim-shorts": ["A", "D"],
    "boxers": ["A", "B"],
    "bra": ["A", "B"],
    "sports-bra": ["A", "B"],
    "leggings": ["A", "D"],
    "thong": ["A", "B"]
  };

  function findProduct(key) {
    var data = window.FRADIME_SIZE_DATA;

    if (!data || !Array.isArray(data.products)) {
      return null;
    }

    return data.products.find(function (product) {
      return product.id === key &&
        product.visible !== false;
    }) || null;
  }

  function findRow(product, code) {
    if (!product || !Array.isArray(product.measurements)) {
      return null;
    }

    return product.measurements.find(function (row) {
      return row.code === code;
    }) || null;
  }

  function getPair(product) {
    if (!product) return null;

    var codes = PAIRS[product.id];
    if (!codes) return null;

    var first = findRow(product, codes[0]);
    var second = findRow(product, codes[1]);

    return first && second
      ? [first, second]
      : null;
  }

  function eligibleSizes(product, allowedSizes) {
    var pair = getPair(product);

    if (!pair || !Array.isArray(product.sizes)) {
      return [];
    }

    var sizes = product.sizes.filter(function (size) {
      return Number.isFinite(pair[0].inches[size]) &&
        Number.isFinite(pair[1].inches[size]);
    });

    if (Array.isArray(allowedSizes)) {
      sizes = sizes.filter(function (size) {
        return allowedSizes.includes(size);
      });
    }

    return sizes;
  }

  function compare(product, measurements, allowedSizes) {
    var pair = getPair(product);

    if (!pair ||
        !Array.isArray(measurements) ||
        measurements.length !== 2) {
      return null;
    }

    var firstValue = measurements[0];
    var secondValue = measurements[1];

    if (!Number.isFinite(firstValue) ||
        !Number.isFinite(secondValue) ||
        firstValue <= 0 ||
        secondValue <= 0) {
      return null;
    }

    var sizes = eligibleSizes(product, allowedSizes);

    if (!sizes.length) return null;

    var matches = sizes.map(function (size) {
      var target1 = pair[0].inches[size];
      var target2 = pair[1].inches[size];

      var error1 = Math.abs(firstValue - target1) / target1;
      var error2 = Math.abs(secondValue - target2) / target2;

      return {
        size: size,
        target1: target1,
        target2: target2,
        error1: error1,
        error2: error2,
        score: error1 * 0.6 + error2 * 0.4
      };
    }).sort(function (a, b) {
      return a.score - b.score;
    });

    var best = matches[0];

    return {
      best: best,
      matches: matches,
      poorMatch: best.score > 0.10 ||
        best.error1 > 0.15 ||
        best.error2 > 0.15
    };
  }

  function toInches(value, unit) {
    return unit === "cm" ? value / 2.54 : value;
  }

  function fromInches(value, unit) {
    return unit === "cm" ? value * 2.54 : value;
  }

  window.FRADIME_SIZE_ENGINE = {
    findProduct: findProduct,
    getPair: getPair,
    eligibleSizes: eligibleSizes,
    compare: compare,
    toInches: toInches,
    fromInches: fromInches
  };
})();
